'use client'

import s from './TestingSliderCatalog.module.scss'
import { useRef } from 'react'
import { NewType, SliderSettings } from '@/types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Swiper as SwiperType } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css'
import CatalogCategory from '@/components/catalog/CatalogCategory'
import NewsCard from '@/components/news/NewsCard'
import CatalogProdCard from '@/components/catalog/CatalogProdCard'
import MaterialsCategory from '@/components/useful-materials/MaterialsCategory'
import { NextButtonTest, PreviousButtonTest } from './TestingButtons/TestingButtons'
import { motion } from 'framer-motion'

// SwiperCore.use([Navigation])

type Props = {
    settings: SliderSettings[]
    type: string
    list: any[] | NewType[]
    linkedCards?: boolean
    zIndex?: number
    lightTheme?: boolean
}

const TestingSliderCatalog: React.FC<Props> = ({ settings, type, list, linkedCards, zIndex, lightTheme }) => {
    const swiperRef = useRef<SwiperType>()
    // const settingsArr = settings[0]

    return (
        settings && (
            <div
                style={{ position: 'relative', width: '100%' }}
                className={s.wrapper}
            >
                <PreviousButtonTest
                    onClick={() => swiperRef.current?.slidePrev()}
                    lightTheme={lightTheme}
                />

                <Swiper
                    style={{
                        position: 'relative',
                        zIndex: zIndex ?? 'auto',
                        minWidth: '270%',
                        overflowY: 'visible'
                    }}
                    slidesPerView={settings[0]?.xxl ?? 2}
                    spaceBetween={20}
                    onBeforeInit={swiper => {
                        swiperRef.current = swiper
                    }}
                >
                    {list &&
                        list.map((slide, i: number) => (
                            <SwiperSlide key={i}>
                                <motion.div
                                    // анимируем каждый слайд отдельно и используем custom для delay
                                    initial='hidden'
                                    whileInView='visible'
                                    viewport={{ once: true }}
                                    variants={{
                                        hidden: {
                                            opacity: 0,
                                            y: -12
                                        },
                                        visible: (index: number) => ({
                                            opacity: 1,
                                            y: 0,
                                            transition: {
                                                // stagger вручную: 0.08s на слайд — подбери под свой вкус
                                                delay: index * 0.3 + .5,
                                                type: 'spring',
                                                stiffness: 180,
                                                damping: 18,
                                                duration: 0.35
                                            }
                                        })
                                    }}
                                    custom={i}
                                >
                                    {type === 'news' ? (
                                        <NewsCard card={slide} />
                                    ) : type === 'materials-products' ? (
                                        <CatalogProdCard
                                            type={type}
                                            item={slide}
                                        />
                                    ) : type === 'useful-materials' ? (
                                        <MaterialsCategory
                                            type='main-slider'
                                            linked={true}
                                            item={slide}
                                            lightTheme={lightTheme}
                                        />
                                    ) : (
                                        <CatalogCategory
                                            linked={linkedCards}
                                            classItem={'categories-slider__card-reverse'}
                                            item={slide}
                                            lightTheme={lightTheme}
                                        />
                                    )}
                                </motion.div>
                            </SwiperSlide>
                        ))}
                </Swiper>

                <NextButtonTest
                    onClick={() => swiperRef.current?.slideNext()}
                    lightTheme={lightTheme}
                />
            </div>
        )
    )
}

export default TestingSliderCatalog
